module.exports = __webpack_public_path__ + "static/media/ckn_platillo.0454441b.jpg";